import React from 'react';
import './mission.css';

function Mission() {
  return (
    <div className="mission-container">
      <div className="mission-content">
        <h1 className="mission-title">Our Mission</h1>
        <p className="mission-intro">
          At <strong>Neelaverse Technologies</strong>, our mission is to empower innovation and transform ideas into intelligent, scalable, and impactful digital solutions.
        </p>

        <div className="mission-blocks">
          <div className="mission-card fade-in">
            <h3>🚀 Empower Startups</h3>
            <p>We help early-stage companies turn concepts into reliable products with speed and agility.</p>
          </div>
          <div className="mission-card fade-in delay-1">
            <h3>🤝 Build Meaningful Solutions</h3>
            <p>We focus on solving real-world problems with technology that adds value and improves lives.</p>
          </div>
          <div className="mission-card fade-in delay-2">
            <h3>🌍 Inspire Innovation</h3>
            <p>We embrace a culture of experimentation, learning, and continuous improvement.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mission;
